"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isDateWithinNumDays = function isDateWithinNumDays(data) {
  return function (_ref) {
    var field = _ref.field;

    if (data && data.numberOfDays) {
      var fromDate = (0, _moment.default)();
      var toDate = (0, _moment.default)().add(data.numberOfDays, 'days');
      var enteredDate = (0, _moment.default)(field.value, 'DD/MM/YYYY'); //isBetween(Starting Moment, Final Moment, Granularity, Inclusive: '[' & ']' exclusive: '(' & ')' )

      var isValid = enteredDate.isBetween(fromDate, toDate, 'days', '[]');
      return [isValid, data.message || "Please enter a date within ".concat(data.numberOfDays, " days of the current date")];
    }

    throw new Error('Data is required with numberOfDays property defined');
  };
};

var _default = isDateWithinNumDays;
exports.default = _default;
//# sourceMappingURL=isDateWithinNumDays.js.map